/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export const emailRegexPattern = new RegExp( //eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
export const phoneRegexPattern = new RegExp(/^(\+\d{1,2}\s?)?\d{3}?[\s.-]?\d{3}[\s.-]?\d{4}$/);
export const usernamePattern = new RegExp('^(?=[A-Za-z0-9._-]{8,30}$)(?!.*[_.]{2})[^_.].*[^_.]$');
export const atLeastOneLowercaseRegex = new RegExp(/^(?=.*[a-z])/)
export const atLeastOneUppercaseRegex = new RegExp(/^(?=.*[A-Z])/)
export const atLeastOneNumericRegex = new RegExp(/^(?=.*[0-9])/)
export const atLeastOneSpecialCharacterRegex = new RegExp(/^(?=.*[\p{S}\p{P}\p{Z}])[\p{L}\p{N}\p{S}\p{P}\p{Z}]/u)
export const atLeast9CharactersRegex = new RegExp(/^(?=.{9,})/);
export const passwordRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\p{S}\p{P}\p{Z}])[\p{L}\p{N}\p{S}\p{P}\p{Z}](?=.{8,})/u)
